import React, { FC } from 'react';

export const Filters: FC = () => {
  return <div></div>;
};
